import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { CompleteRegistrationApiResult } from '../../Models/Client/CompleteRegistrationApiResult';
import { GetRegistrationApiModel } from '@public/src/api/generated/models';

export interface RegisterClientModel {
	Nationality: string;
	NationalIdentityNumber: string;
	Phone: string;
	FirstName: string;
	LastName: string;
	Email: string;
	PhoneVerificationAttemptId?: string;
}

@Injectable()
export class RegistrationService {
	readonly baseUri: string = '/Api/Client/v2/Registration';

	constructor(private http: VisibaApiHttp) {}

	public getRegistration(ticket: string): Observable<ApiResponse<GetRegistrationApiModel>> {
		return this.http.getTyped<GetRegistrationApiModel>(`${this.baseUri}/Registration/${ticket}`);
	}

	public completeRegistration(ticket: string, postData: any): Observable<ApiResponse<void>> {
		return this.http.postTyped<void>(`${this.baseUri}/Registration/${ticket}`, postData);
	}
}
